import { baseApiUrl } from '@fund-base/constants/general/general.constants';

export const getOrganizationSettingsApiUrl = `${baseApiUrl}/organization/settings`;
export const updateOrganizationSettingsApiUrl = `${baseApiUrl}/organization/update-organization-settings`;
export const updateOrganizationOnboardingCompletedApiUrl = `${baseApiUrl}/organization/completed`;
export const getOrganizationUsersListApiUrl = `${baseApiUrl}/organization/users-list`;
export const addNewUserApiUrl = `${baseApiUrl}/organization/add-new-user`;
export const deleteUserFromOrganizationApiUrl = `${baseApiUrl}/organization/user`;
export const deleteInvoiceApiUrl = `${baseApiUrl}/organization/invoice`;
